<template>
    <div>
        <div class="p-3 news__block__card h-100 cursor-pointer d-flex flex-column justify-content-between gap-3">
            <div class="news__block__card__imgBox d-flex position-relative justify-content-center">
                <button class="news__block__card__imgBox-btn border-0 position-absolute">
                    Sponsor
                </button>
                <ImageWithFallback :src="image" class="news__block__card__imgBox-img user-select-none pe-none" />
            </div>

            <div class="news__block__card__imgBox-text d-flex justify-content-between align-items-end">
                <div class="d-flex justify-content-between align-items-center w-100 gap-3">
                    <p class="align-content-center mb-0">
                        {{ headingText }}
                    </p>
                    <button class="news__block__card__imgBox-icon m-0 p-1">
                        <i class="fa-solid fa-chevron-right text-muted px-1"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ImageWithFallback from "@/components/ImageWithFallback.vue";

export default {
    props: { btnText: String, image: String, headingText: String, logo: String },
    components: {
        ImageWithFallback,
    },
}
</script>
